import { LensTile, LensTileSize } from "../LensTile";
import styles from "./LensGrid.module.css";
export function LensGrid({ lenses, enableLargePreview, enableVideoPreview }) {
    const size = enableLargePreview ? LensTileSize.large : LensTileSize.medium;
    return (<div className={styles.grid} data-testid="lensGrid">
      {lenses.map((lensDisplayInfo, index) => (<div key={index} className={styles.item} data-testid="lensGridItem">
          <LensTile lensDisplayInfo={lensDisplayInfo} useBoldTitle enableVideoPreview={enableVideoPreview} size={size}/>
        </div>))}
    </div>);
}
